<script lang="ts" setup>
import FeedbackForm from '@/components/feedback/FeedbackForm.vue';
import { Feedback } from '@/models/feedback.model';
import { Mutations, ShiftCMSState } from '@/store';
import { FeedbackActions, FeedbackState } from '@/stores/feedback.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';

const store = useStore<ShiftCMSState & { fs: FeedbackState }>();
const feedback = computed<Feedback[]>(() => store.state.fs.feedback);

const update = () => {
  store.dispatch(FeedbackActions.GetFeedback);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const showFeedback = (_: Event, { item }: { item: Feedback }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(FeedbackForm),
    data: item,
  });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Message', key: 'message' },
  { title: 'Resolved', key: 'resolved' },
  { title: 'User', key: 'user.name' },
  { title: 'Date', key: 'creationDate' },
];
</script>

<template>
  <v-container>
    <h2>Feedback</h2>

    <v-data-table
      density="compact"
      @click:row="showFeedback"
      :headers="headers"
      :items="feedback"
      itemsPerPage="25"
      :sortBy="[{ key: 'creationDate', order: 'desc' }]"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
      <template v-slot:item.resolved="{ value }">
        <v-icon icon="mdi-check" v-if="value" />
        <v-icon icon="mdi-circle-off-outline" v-if="!value" />
      </template> </v-data-table
  ></v-container>
</template>
